/**
 * Sticky Checkout Now bar for the cart page: appears once the real
 * Checkout Now button has scrolled out of view above the viewport.
 * Tapping it forwards a click to the real button, which submits the
 * same cart form via its `form` attribute, so no logic is duplicated.
 *
 * Cart quantity/remove updates replace #Main-Cart-Details (and the real
 * button inside it) over AJAX, so this re-binds on the theme's cartUpdate
 * pub/sub event, mirroring how the product page re-binds on variantChange.
 *
 * While visible, it also pushes the floating tool-bar widget up by its own
 * height via the --sticky-atc-push custom property, so the two don't overlap.
 */
(function () {
  var observers = {};
  var lastVisibleState = {};

  function setPush(bar, visible) {
    var push = visible ? bar.offsetHeight + "px" : "0px";
    document.documentElement.style.setProperty("--sticky-atc-push", push);
  }

  function setUpBar(bar) {
    var sectionId = bar.dataset.section;

    if (observers[sectionId]) {
      observers[sectionId].disconnect();
      delete observers[sectionId];
    }

    var realButton = document.querySelector("#Main-Cart .cart-checkout-button");
    var stickyButton = bar.querySelector(".sticky-checkout-button");

    if (!realButton || !stickyButton) {
      bar.classList.remove("sticky-checkout-bar--visible");
      lastVisibleState[sectionId] = false;
      setPush(bar, false);
      return;
    }

    if (lastVisibleState[sectionId]) {
      bar.classList.add("sticky-checkout-bar--visible");
      setPush(bar, true);
    }

    var realCS = getComputedStyle(realButton);
    stickyButton.style.fontSize = realCS.fontSize;
    stickyButton.style.paddingTop = realCS.paddingTop;
    stickyButton.style.paddingBottom = realCS.paddingBottom;
    stickyButton.style.paddingLeft = realCS.paddingLeft;
    stickyButton.style.paddingRight = realCS.paddingRight;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var isPastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        lastVisibleState[sectionId] = isPastButton;
        bar.classList.toggle("sticky-checkout-bar--visible", isPastButton);
        setPush(bar, isPastButton);
      },
      { threshold: 0 },
    );
    observer.observe(realButton);
    observers[sectionId] = observer;

    stickyButton.onclick = function () {
      var currentRealButton = document.querySelector("#Main-Cart .cart-checkout-button");
      if (currentRealButton) currentRealButton.click();
    };
  }

  function initAll() {
    document.querySelectorAll(".sticky-checkout-bar").forEach(setUpBar);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  if (typeof webvista !== "undefined" && webvista.subscribe) {
    webvista.subscribe(PUB_SUB_EVENTS.cartUpdate, initAll);
  }
})();
